import { AccessRightFilterCollectionModel } from '@fi-shared/models';
import { PublicationSettingModel } from '@fi-shared/models';
import { DocumentSettingModel } from '@fi-app/document/document-setting.model';
import { FiCommentSettingType } from '@fi-shared/types';

export class WordImport {
    IsPublished = false;
    TemplateId = 1;
    FileContent = '';
    CreatedByUserId = undefined;
    CreatedByUserName = '';
    ContentLanguageId = 0;
    AccessRightFilterCollection = new AccessRightFilterCollectionModel();
    PublicationSetting = new PublicationSettingModel();
    DocumentSetting = new DocumentSettingModel();

    constructor() {
        this.DocumentSetting.CommentSettingType = FiCommentSettingType.AllowAllComments;
    }
}
